import classNames from 'classnames';
import {CSSProperties, DetailedHTMLProps, FC, HTMLAttributes} from 'react';
import styles from './MeinText.module.css';

interface IBaseProps extends DetailedHTMLProps<
    HTMLAttributes<HTMLParagraphElement>,
    HTMLParagraphElement
> {
    tag?: 'p' | 'span' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
    linesToClamp?: number;
    underline?: boolean;
}

export type DefaultTextSize = 's' | 'm' | 'l' | 'xl';

type DefaultTextProps = IBaseProps & {
    type?: 'default';
    size?: DefaultTextSize;
};

type TitleTextProps = IBaseProps & {
    type: 'title';
    size?: 's' | 'm' | 'l';
};

type LabelTextProps = IBaseProps & {
    type: 'label';
    size?: 'xs' | 's' | 'm' | 'l';
};

type HeadlineTextProps = IBaseProps & {
    type: 'headline';
    size?: 's' | 'm' | 'l';
};

type IProps =
    | DefaultTextProps
    | TitleTextProps
    | LabelTextProps
    | HeadlineTextProps;

export const MeinText: FC<IProps> = ({
    tag: Tag = 'p',
    size = 'm',
    type = 'default',
    linesToClamp,
    className,
    children,
    underline,
    ...rest
}) => {
    const sizeClass = size ? styles[size] : styles.l;
    const lineClampStyles: CSSProperties = {
        /* other required truncate styles are applied though class .truncate */
        WebkitLineClamp: linesToClamp,
    };

    return (
        <Tag
            className={classNames(
                styles.text,
                styles[type],
                sizeClass,
                className,
                {
                    [styles.truncate]: linesToClamp,
                    [styles.underline]: underline,
                },
            )}
            style={{...(linesToClamp && lineClampStyles)}}
            {...rest}
        >
            {children}
        </Tag>
    );
};
